import AbstractHTML5Player from '../all/AbstractHTML5Player';
import * as playerConstants from '../../utils/playerConstants';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';
class NetrangePlayer extends AbstractHTML5Player {
  constructor() {
    super();
  }

  getStreamType() {
    switch (this.options.streamType) {
      case playerConstants.HLS:
      case playerConstants.HLS_KR:
        return 'application/vnd.apple.mpegurl';
        break;
      case playerConstants.AUDIO:
      case playerConstants.RADIO:
        return 'audio/mp4';
        break;
      case playerConstants.SS:
      case playerConstants.SS_MA:
        return 'application/vnd.ms-playready.initiator+xml';
        break;
      default:
        return null;
        break;
    }
  }

  setVideoSource(url, type) {
    logger.debug('******* <<<<<<<<<<< INIT netrange AbstractHTML5Player setVideoSource: ' + url);
    let source = document.createElement('source');
    source.src = url;

    logger.debug('ESV: setting stream type', this.options.streamType, this.getStreamType());
    type = this.getStreamType();
    if (type) source.type = type;

    source.id = 'Html5PlayerSource' + (this.options.isPip ? '_pip' : '_full');
    this._playerHTMLTag.appendChild(source);

    logger.debug('******* <<<<<<<<<<< END netrange AbstractHTML5Player setVideoSource');
  }

  getAudioIndexOfCode(codeTrack) {
    if (Utils.isNetrangeBravia())
      return this.audioTracks.findIndex(track => {
        return this.getLanguageCodeByISO3(codeTrack) === track.language;
      });
    else return this.audioTracks.findIndex(track => track.language === codeTrack);
  }
}

export default NetrangePlayer;



// WEBPACK FOOTER //
// ./src/devices/netrange/Player.js